import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b808779e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "flex gap-4 justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "RUH - liste", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Inger RUHer", -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HcButton = _resolveComponent("HcButton")!
  const _component_RfpFilter = _resolveComponent("RfpFilter")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_HcButton, {
          color: "green",
          type: "inertia-link",
          href: _ctx.route('rfp.create')
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ny RUH ")
          ]),
          _: 1
        }, 8, ["href"])
      ])
    ]),
    _createVNode(_component_RfpFilter, {
      modelValue: _ctx.filter,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
      allCategories: _ctx.allCategories
    }, null, 8, ["modelValue", "allCategories"]),
    (_ctx.total == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    _createVNode(_component_Datatable, {
      onRowClicked: _ctx.navigateToRfp,
      columnDefs: _ctx.columns,
      mobileColumnDefs: _ctx.mobileColumnDefs,
      defaultSortModel: _ctx.defaultSortModel,
      routeName: _ctx.routeName,
      filter: _ctx.filter,
      responseTransformer: _ctx.responseTransformer
    }, null, 8, ["onRowClicked", "columnDefs", "mobileColumnDefs", "defaultSortModel", "routeName", "filter", "responseTransformer"])
  ]))
}